import i18n from '@/plugins/i18n';
import {
  CAPABILITY_APM,
  CAPABILITY_VM,
  CAPABILITY_K8M,
  CAPABILITY_BROWSER,
  CAPABILITY_MOBILE,
} from '@/utils/constants';

const Messages = {
  APDEX_CONSTANT: {
    BROWSER_APP_APDEX: 'browser_app_apdex',
    SERVICE_APDEX: 'service_apdex',
  },
  OTHERS_CONSTANT: {
    RULE_NAME: 'ruleName',
    PERIOD: 'period',
    _PERIOD: 'Period',
    NO_OF_BREACHES: 'noOfBreaches',
    RECOVERY_PERIOD: 'recoveryPeriod',
    SILENCE_PERIOD: 'silencePeriod',
    SERVICE_ID: 'serviceId',
    BAD_REQUEST: 'BAD_REQUEST',
    THRESHOLD: 'Threshold',
    THRESHOLD_VALID_LIMIT: 'ThresholdValidLimit',
    INSTANCE_AVAILABILITY: 'Instance availability',
    AVAILABILITY: 'Availability',
  },
};

export default Object.freeze(Messages);

export const MAX_ENDPOINT_SELECTED = 20;
export const ANOMALY_COUNT = 'ANOMALY';
export const ANOMALY_COUNT_LABEL = i18n.global.t('alert.anomaly-count');
export const CRITICAL = 'Critical';
export const MAJOR = 'Major';
export const MINOR = 'Minor';
export const CRITICAL_AND_MAJOR = 'Critical & Major';
export const CRITICAL_AND_MAJOR_AND_MINOR = 'Critical & Major & Minor';
export const CRITICAL_AND_MAJOR_ALERT_MESSAGE = i18n.global.t(
  'alert.critical_major_sev_message',
);
export const CRITICAL_MAJOR_AND_MINOR_ALERT_MESSAGE = i18n.global.t(
  'alert.critical_major_minor_sev_message',
);
export const SEVERITY_OPTIONS = [
  { key: CRITICAL, label: i18n.global.t('alert.critical_sev') },
  { key: MAJOR, label: i18n.global.t('alert.major_sev') },
  // { key: MINOR, label: i18n.global.t('alert.minor_sev') },
  { key: CRITICAL_AND_MAJOR, label: i18n.global.t('alert.critical_major_sev') },
  // {
  //   key: CRITICAL_AND_MAJOR_AND_MINOR,
  //   label: i18n.global.t('alert.critical_major_minor_sev'),
  // },
];
export const COUCHBASE_CLUSTER = 'cluster';
export const COUCHBASE_NODE = 'node';
export const COUCHBASE_BUCKET = 'bucket';
export const CUSTOM_DB = 'CDQ';
export const COUCHBASE_SUB = 'CB';
export const MYSQL_SUB = 'MY';
export const MSSQL_SUB = 'MS';
export const CASSANDRA_SUB = 'CA';
export const ORACLE_SUB = 'OR';
export const POSTGRES_SUB = 'PG';

// export const MSSQL_SUB = 'MS';
export const POSTGRES_INSTANCE = 'pos-instance';
export const MONGO_SUB = 'MG';
export const ORACLE_INSTANCE = 'ora-instance';
export const CASSASDRA_INSTANCE = 'cas-instance';
export const NODE = 'node';
export const MSSQL_INSTANCE = 'ms-instance';
export const MONGO_INSTANCE = 'mg-instance';

export const MQ = 'Q';
export const MQ_ACTIVEMQ = 'AR';
export const BROKER = 'broker';
export const QUEUE = 'queue';
export const TOPIC = 'topic';
export const MAX_INSTANCE_SELECTED = 20;
export const MQ_INSTANCE_LIMIT = 20;

export const METRIC = 'metric';
export const INSTANCE = 'instance';
export const DATABSE = 'database';

export const CUSTOM_METRIC = 'meter_custom_db_queries';
export const CUSTOM_POSTGRES_METRICS = 'meter_postgres_custom_db_queries';
export const K8_SUB = 'K';
export const CLOUD = 'C';
export const K8_CLUSTER_INSTANCE = 'cluster';
export const K8M_NODE = 'node';
export const K8M_DEP = 'deployment';
export const K8M_DAEMON = 'daemonset';
export const K8M_STAT = 'statefulset';
export const K8M_POD = 'pod';
export const K8M_NAMESPACE = 'namespace';
export const K8M_INSTANCE_LIMIT = 20;
export const CONSUMER = 'consumer';
export const PRODUCER = 'producer';
export const CRITICAL_SEV = 3;

export const MQ_INSTANCE_LABEL_MAPPING = {
  [BROKER]: i18n.global.t('alert.broker'),
  [QUEUE]: i18n.global.t('alert.queue'),
  [TOPIC]: i18n.global.t('alert.topic'),
  [PRODUCER]: i18n.global.t('alert.producer'),
  [CONSUMER]: i18n.global.t('alert.consumer'),
};

export const MQ_INSTANCE_SEARCH_TXT_MAPPING = {
  [BROKER]: i18n.global.t('alert.searchBroker'),
  [QUEUE]: i18n.global.t('alert.searchQueue'),
  [TOPIC]: i18n.global.t('alert.searchTopic'),
  [PRODUCER]: i18n.global.t('alert.searchProducer'),
  [CONSUMER]: i18n.global.t('alert.searchConsumer'),
};
export const AWS = {
  AWS: 'AWS',
  AWS_RDS: 'AWS RDS',
  MYSQL: 'MYSQL',
  LAMBDA: 'LAMBDA',
  ELASTICACHE: 'ELASTICACHE',
};

export const AWS_ALERT_CAPABILITIES = [
  { value: 'aws', label: i18n.global.t('aws.aws') },
];
export const DATABASE_TYPE = [
  { value: 'mysql', label: i18n.global.t('aws.mysql') },
];
export const RDS_ALERT_CAPABILITIES = [
  { value: 'RDS_MYSQL', label: i18n.global.t('aws.RdsMysql') },
  { value: 'RDS_MSSQL', label: i18n.global.t('aws.RdsMssql') },
  { value: 'RDS_POSTGRES', label: i18n.global.t('aws.RdsPostgress') },
  { value: 'LAMBDA', label: i18n.global.t('aws.lambda') },
  { value: 'ELASTICACHE', label: i18n.global.t('aws.elastiCache') },
  { value: 'ELB', label: i18n.global.t('aws.ingress') },
];

export const ALERT_CAPABILITY_TYPE = {
  AWS: 'AWS',
  RDS: 'RDS',
  CLOUD_MONITORING: 'Cloud monitoring',
};

export const ALERT_SUB_TYPES = {
  MYSQL: 'RDS_MYSQL',
  MSSQL: 'RDS_MSSQL',
  POSTGRES: 'RDS_POSTGRES',
  LAMBDA: 'LAMBDA',
  ELASTICACHE: 'ELASTICACHE',
  INGRESS: 'ELB',
};

export const ALL_SELECTED_INSTANCES = {
  key: 'ALL',
  label: i18n.global.t('aws.all'),
  selected: false,
};

export const CLOUD_SUB_TYPE_MAPPER = {
  RDS: 'RDS',
  LAMBDA: 'LAMBDA',
  ELB: 'INGRESS',
  ELASTICACHE: 'ELASTICACHE',
};

export const AI_CAPABILITIES = [
  CAPABILITY_APM,
  CAPABILITY_VM,
  CAPABILITY_K8M,
  CAPABILITY_BROWSER,
  CAPABILITY_MOBILE,
];
